export const getDevicePlatform = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (
            getDevicePlatform.Android() ||
            getDevicePlatform.BlackBerry() ||
            getDevicePlatform.iOS() ||
            getDevicePlatform.Opera() ||
            getDevicePlatform.Windows()
        );
    },
};

// This function checks if a rich text field is blank as kontent.ai returns "<p><br></p>" for blank fields.
export const isRichTextFieldBlank = (
    richtext: string | null | undefined
): boolean => {
    if (richtext == null || !String(richtext).trim()) return true;
    return richtext === '<p><br></p>';
};

export const getAlgoliaIndexPrefix = (env: string | undefined): string =>
    env === 'PROD'
        ? 'PROD___'
        : env === 'DEV'
        ? 'DEV___'
        : env === 'STAGE'
        ? 'STAGE___'
        : 'PROTOTYPE___';

/**
 * Convert a (possibly normalized/lowercased) Kontent language codename back to
 * the canonical case used when building Algolia indexes in
 * `src/utils/algolia-queries.js` and listed in `languages.json`.
 *
 * The Algolia index suffixes are case-sensitive (e.g. `..._GB-en`, `..._AU-en`,
 * `..._default`). However `Page.tsx` lowercases `preferredLanguage` via
 * `normalizeLocale()` before putting it on `PageMetadataContext`, so consumers
 * that build an index name from the context value would otherwise produce
 * mismatched names (e.g. `..._gb-en`) and silently fail to return any results
 * for non-US regions.
 *
 * Mapping examples:
 *   undefined / ''  -> 'default'
 *   'default'       -> 'default'
 *   'gb-en'         -> 'GB-en'
 *   'au-en'         -> 'AU-en'
 *   'de-de'         -> 'DE-de'
 */
export const getAlgoliaLangSuffix = (
    lang: string | undefined | null
): string => {
    if (!lang) return 'default';
    const lower = String(lang).toLowerCase();
    if (lower === 'default') return 'default';
    const [country, language] = lower.split('-');
    if (!country || !language) return lower;
    return `${country.toUpperCase()}-${language}`;
};
